import { FC } from 'react';
import useAuth from 'store/Auth/useAuth';
import { ReactComponent as SupportIcon } from 'atoms/icons/svg/support.svg';
import SidebarMenuItem from 'components/SidebarMenu/item';
import { useTranslation } from 'react-i18next';
import ButtonV2 from 'atoms/components/Buttons/V2/ButtonV2';

type Props = {
  isSideBar?: boolean;
  isExpanded?: boolean;
};

const SupportBtn: FC<Props> = ({ isSideBar, isExpanded }) => {
  const handleSupport = () => {
    window.location.href =
      'mailto:support@remorarobotics.no?subject=Support Request';
  };
  const { isCustomer } = useAuth();
  const { t } = useTranslation();

  // we displaying the support btn for customer in header @see CustomerHeader
  if (isSideBar && isCustomer) {
    return <></>;
  }

  if (isSideBar) {
    return (
      <SidebarMenuItem
        name={t('Support')}
        icon={<SupportIcon />}
        isExpanded={isExpanded}
        onClick={handleSupport}
      />
    );
  }

  return (
    <ButtonV2 size="m" type="tertiary" onClick={handleSupport}>
      {t('Support')}
    </ButtonV2>
  );
};

export default SupportBtn;
